import { render, staticRenderFns } from "./extend_tab.vue?vue&type=template&id=61ddd15a&scoped=true&"
import script from "./extend_tab.vue?vue&type=script&lang=js&"
export * from "./extend_tab.vue?vue&type=script&lang=js&"
import style0 from "./extend_tab.vue?vue&type=style&index=0&id=61ddd15a&scoped=true&lang=less&"
import style1 from "./extend_tab.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ddd15a",
  null
  
)

export default component.exports